<mat-progress-bar
    role="progressbar"
    aria-label="Progress status bar"
    mode="determinate"
    value="{{ status }}"
    color="primary"
></mat-progress-bar>
